import React from "react"

import { Image } from "components/anti/image/image"
import { Button } from "components/anti/buttons/buttons"
import { Link } from "components/anti/link/link"
import { useScrollAnim } from "src/components/hooks/hooks"


export const ProjectDetailsLocation = ({ data }) => {
    const [trigger, anim] = useScrollAnim()

    return (
        <section className="bg-light sc-projectDetails-location" ref={trigger}>
            {/* <Image src={data.maps.image.sourceUrl} className="img-fluid w-100 h-md-500px" alt="maps" /> */}
            <div className="py-main">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <h2 className={`${anim(1)}`}>{data?.address?.title}</h2>
                            <div dangerouslySetInnerHTML={{ __html: data?.address?.text }} className={`${anim(2)}`} />
                            <Button variant="link" link={data?.address?.button?.url} className={`${anim(3)}`}>
                                {data?.address?.button?.text}
                            </Button>
                        </div>
                        {data.social && (
                            <ul className="social pb-5 px-2 order-md-last">
                                {data.social.map((item, i) => {
                                    return (
                                        <li key={i} className={`social-item ${anim(4 + i)}`}>
                                            <a href={item?.url}>
                                                <amp-img
                                                    src={item?.icon?.sourceUrl}
                                                    width="64"
                                                    height="64"
                                                    class="img-fluid"
                                                />
                                            </a>
                                        </li>
                                    )
                                })}
                            </ul>
                        )}
                        <div className="col-md-8 row">
                            <div className="col-md-6">
                                <h2 className={`${anim(5)}`}>{data?.accessNearby?.title}</h2>
                                <p className={`font-weight-light text-gray-600 ${anim(5)}`}>{data?.accessNearby?.text}</p>
                            </div>
                            <div className="col-md-6">
                                <h2 className={`${anim(6)}`}>{data?.facilities?.title}</h2>
                                <p className={`font-weight-light text-gray-600 ${anim(6)}`}>{data?.facilities?.text}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}